// Display formatters. PLAN.md §4.2 — 2dp + tabular-nums for all currency.

const DEFAULT_USD = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const ABBREV_USD = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function fmtUsd(n: number): string {
  return `$${DEFAULT_USD.format(n)}`
}

/** PLAN.md §4.2 — pill auto-abbreviates at 7+ digits. */
export function fmtUsdAbbrev(n: number): string {
  const abs = Math.abs(n)
  if (abs >= 1_000_000_000) {
    return `${n < 0 ? '-' : ''}$${ABBREV_USD.format(abs / 1_000_000_000)}B`
  }
  if (abs >= 1_000_000) {
    return `${n < 0 ? '-' : ''}$${ABBREV_USD.format(abs / 1_000_000)}M`
  }
  return fmtUsd(n)
}

export function fmtUsdSigned(n: number): string {
  if (n > 0) return `+${fmtUsd(n)}`
  if (n < 0) return `-${fmtUsd(Math.abs(n))}`
  return fmtUsd(0)
}

export function fmtTimeShort(iso: string): string {
  const d = new Date(iso)
  return d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
}
